import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useConfig } from 'wagmi'

import { useChainConfigEntry } from '@/domain/hooks/useChainConfigEntry'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'
import { getApprovalsQueryOptions } from '@/features/actions/logic/useTokenApprovals'

export function usePrefetchTokenApprovals(): void {
  const queryClient = useQueryClient()
  const wagmiConfig = useConfig()
  const chainConfig = useChainConfigEntry()
  const { account, chainId } = useConnectedAddress({ throwOnNotConnected: false })

  useEffect(() => {
    if (!account) return
    const { queries } = getApprovalsQueryOptions({ chainId, account, wagmiConfig, chainConfig })
    for (const query of queries) {
      void queryClient.prefetchQuery(query)
    }
  }, [queryClient, chainConfig, wagmiConfig, account, chainId])
}
